module.exports = __webpack_public_path__ + "img/BookingVectorIcon.504cad77.svg";